export const SETTINGS_ORGANIZATION_COPY = {
	AUTHENTICATION_HEADER: 'Organization Authentication',
	CONNECTED_ORGANIZATIONS: 'Connected Organizations',
	DISCONNECT: 'Disconnect',
	DISCONNECT_MESSAGE: 'By disconnecting this organization, all historical sync data and tags will be lost.',
	DISCONNECT_TITLE: (name: string): string => `Unlink ${name} from Arovy?`,
	DISCONNECT_WARNING: 'Cannot remove your only Organization',
	INSTANCE_URL: 'Instance URL',
	LAST_SUCCESSFUL_SYNC: 'Last Successful Sync',
	LINK_NEW_SALESFORCE_ORGANIZATION: 'Link New Salesforce Org',
	LINK_NEW_SALESFORCE_SANDBOX: 'Link New Sandbox Org',
	ORGANIZATIONS_TABLE: 'Organizations Table',
	ORGANIZATION_NAME: 'Organization Name',
	PACKAGE_TAGGING: 'Package Tagging',
	PRODUCTION: 'Production',
	REAUTHORIZE: 'Reauthorize',
	SALESFORCE_USERNAME: 'Salesforce Username',
	SANDBOX: 'Sandbox',
	SANDBOX_TITLE: 'Sandbox?',
	SYNC_STATUS: 'Sync Status'
};
